import React, { useEffect, useState } from "react";
import "./home.scss";
import HeaderBar from "../../components/headerBar/HeaderBar";
import DailyProgram from "./components/dailyProgram/DailyProgram";
import AssociationBox from "../../components/associationBox/AssociationBox";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import ListEvent from "./components/listEvent/ListEvent";
import WhatsappChannelBanner from "./components/whatsappChannelBanner/WhatsappChannelBanner.jsx";

import { t } from "i18next";
import { setGlobalState } from "../../utils/state";
import {
  getDailyProgramWS,
  getFavourtieAssociationsWS,
  getAssociationWhereIAmVolunteerWS,
  getFeedEventsWS,
} from "./api/homeAPI.js";
import { isEmpty } from "../../utils/validation.js";
import { useScreenSize } from "../../ScreenSizeContext.js";
import { Col, Row } from "react-bootstrap";

const Home = () => {
  const isPC = useScreenSize();

  const [dailyPrograms, setDailyPrograms] = useState({});
  const [favouriteAssociation, setFavouriteAssociation] = useState([]);
  const [associationWhereIAmVolunteer, setAssociationWhereIAmVolunteer] =
    useState([]);
  const [feedEvents, setFeedEvents] = useState([]);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 1);
    getDailyProgramWS()
      .then((res) => setDailyPrograms(res))
      .catch((err) => console.log(err));
    getFavourtieAssociationsWS({ favourite: true })
      .then((res) => setFavouriteAssociation(res))
      .catch((err) => console.log(err));
    getFeedEventsWS({ limit: 10 })
      .then((res) => setFeedEvents(res))
      .catch((err) => console.log(err));
    getAssociationWhereIAmVolunteerWS({ limit: 8 })
      .then((res) => setAssociationWhereIAmVolunteer(res))
      .catch((err) => console.log(err));
  }, []);

  return (
    <>
      <HeaderBar
        title={!isPC ? t("common.name_application") : t("common.home")}
      />
      <div className="container-responsive">
        <Row sm={1} md={1} lg={2} xl={2}>
          <Col className="order-lg-2 d-flex justify-content-center ">
            {!isEmpty(dailyPrograms) ? (
              <DailyProgram data={dailyPrograms} />
            ) : null}
          </Col>
          <Col className="order-lg-1 container-scrollable-homepage">
            {!isEmpty(associationWhereIAmVolunteer) ? (
              <AssociationBox
                title={t("home.volunteer_of_association")}
                data={associationWhereIAmVolunteer}
                link={"/list-associations?type=volunteer"}
              />
            ) : null}
            {!isEmpty(feedEvents) ? (
              <ListEvent
                title={t("home.activity_of_your_association")}
                data={feedEvents}
              />
            ) : null}
            <WhatsappChannelBanner />
            {!isEmpty(favouriteAssociation) ? (
              <AssociationBox
                title={t("home.follow_association")}
                type={2}
                data={favouriteAssociation}
                link={"/list-associations?type=follow"}
                viewLike={false}
              />
            ) : null}
          </Col>
        </Row>
        <VoidSpace />
      </div>
    </>
  );
};

export default Home;
